import { Component, EventEmitter, inject, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-sms-call-terms-modal',
  templateUrl: './sms-call-terms-modal.component.html',
  styleUrls: ['./sms-call-terms-modal.component.css'],
  imports: []
})
export class SmsCallTermsModalComponent {

  // Properties
  @Output() agreed: EventEmitter<void> = new EventEmitter<void>();

  // Injections
  modal = inject(NgbActiveModal);

  // Accept Terms
  acceptTerms() {
    this.agreed.emit();
    this.modal.close();
  }
}
